import { render, staticRenderFns } from "./AddressToggleChip.vue?vue&type=template&id=54326186"
import script from "./AddressToggleChip.vue?vue&type=script&lang=ts"
export * from "./AddressToggleChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports